import { Bem } from "@common/utils";

const cn = new Bem({
  name: "multi-list",
  prefix: "pfx-",
});

export const multiListCnFn = (className) => cn(undefined, undefined, className);
